import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export default function InfoHelp({ label, children }) {
  const [open, setOpen] = React.useState(false);
  const id = React.useId();
  return (
    <TooltipProvider delayDuration={250}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button type="button" aria-label={`Informações sobre ${label}`} aria-describedby={id} aria-expanded={open}
            onClick={(event) => { event.preventDefault(); event.stopPropagation(); setOpen(!open); }}
            className="inline-flex size-7 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary align-middle">
            <Info className="size-4" aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <span id={id} className="sr-only">{children}</span>
        <TooltipContent className="z-[100] max-w-[min(320px,85vw)] border border-border bg-popover p-3 text-sm leading-relaxed text-popover-foreground shadow-xl">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
